export default {
    MAIN_PAGE: '/',
    LOGIN: '/login',
    LOGOUT: '/odhlaseni',
    REDIRECT_ERR: '/bankid-chyba',
    LOGIN_TOKEN: '/login/:tokenURL?',
    PXKLIC_LOGIN: '/login-pxklic',
    AKCIONAR_SMS: '/sms/:tokenURL?',
    REGISTRACE: '/registrace',
    REGISTRACE_POTVRZENI: '/registrace-potvrzeni/:tokenURL?',
    REGISTRACE_MAJETKU: '/registracemajetku/:tokenURL?',
    ZADOST_OBNOVENI_HESLA: '/zadost-obnoveni-hesla',
    ZADOST_OBNOVENI_HESLA_LEI: '/zadost-obnoveni-hesla-lei',
    ZMENA_HESLA: '/zmena-hesla',
    OBNOVENI_HESLA_LEI: '/obnoveni-hesla-lei/:id?',
    OBNOVENI_HESLA: '/obnoveni-hesla/:id?',
    ZMENA_EMAILU_PROFIL: '/zmena-loginu',
    ZMENA_EMAILU: '/zmena-emailu/:id?',
    FIRMA: '/firma/:company',
    FIRMA_PLAIN: '/firma/',
    PREHLED: '/prehled',
    NOVY_UCET: '/novy-ucet/:typ?',
    MUJ_PROFIL: '/muj-profil',
    PREHLED_AKCIONAR: '/prehled-akcionar',
    PREHLED_SPRAVCE: '/prehled-spravce-uctu',
    PREHLED_UCASTNIK_HLASOVANI: '/prehled-ucastnik-hlasovani',
    PREHLED_UCASTNIK: '/prehled-ucastnik',
    UDALOSTI_AKCIONAR: '/udalosti-akcionar',
    HLASOVANI_AKCIONAR: '/hlasovani-akcionar',
    HLASOVANI_HROMADNE: '/hlasovani-spravce/hromadne/:id?',
    HLASOVANI_SPRAVCE: '/hlasovani-spravce/:oid?/:id?',
    EMISE_PREHLED: '/emise',
    EMISE_REGI_ISIN: '/emise-registrace-isin',
    EMISE_NOVY_ISIN: '/emise-novy-isin',
    EMISE_ZMENY_ISIN: '/emise-zmeny-isin',
    EMISE_ZRUSENI_ISIN: '/emise-zruseni-isin',
    EMISE_PODANE_ZADOSTI: '/emise-podane-zadosti',
    EMISE_ROZCESTNIK: '/emise-rozcestnik',
    KORPORATNI_AKCE: '/korporatni-akce',
    NOVA_UDALOST: '/nova-udalost',
    DETAIL_KORPORATNI_AKCE: '/detail-korporatni-akce',
    DETAIL_KORPORATNI_AKCE_ID: '/detail-korporatni-akce/:id?',
    PRUVODCE_SRD_VH: '/pruvodce-srd-vh',
    PRUVODCE_SRD_VYPIS: '/pruvodce-srd-vypis',
    PREHLED_SPRAVA_EMITENTA: '/prehled-emitent',
    PREHLED_EMITENT: '/sprava-emitenta',
    PREHLED_PRAVNICKA: '/sprava-pravnicke-osoby',
    AMLZ_FORMULAR: '/amlz-formular',
    AMLZ_OSOBY: '/amlz-osoby',
    AMLZ_ZADOST_O_AGENDU: '/amlz-agenda-zadost',
    AMLZ_ZADOST_O_AGENDU_LOGIN: '/amlz-agenda-zadost-login/:hash?',
    REDIRECT_LOGIN_DLT: '/redirect-dlt/:lang?/:hash?',
    REDIRECT_LOGIN: '/redirect-login/:hash?',
    DLT_PO_ZASTUPUJICI_OSOBY: '/pravnickaosoba-zastupujici-osoby',
    DLT_PO_ZASTUPUJICI_OSOBY_ZADOST: '/pravnickaosoba-zastupujici-osoby-zadost',
    DLT_PO_ZASTUPUJICI_OSOBY_NOVA: '/pravnickaosoba-zastupujici-osoby-nova',
    DLT_PO_ZASTUPUJICI_OSOBY_EDITACE: '/pravnickaosoba-zastupujici-osoby-editace',
    DLT_PO_ZASTUPUJICI_OSOBY_HISTORY: '/pravnickaosoba-zastupujici-osoby-historie',
    EMITENT_ZASTUPUJICI_OSOBY: '/emitent-zastupujici-osoby',
    EMITENT_ZASTUPUJICI_OSOBY_ZADOST: '/emitent-zastupujici-osoby-zadost',
    EMITENT_ZASTUPUJICI_OSOBY_NOVA: '/emitent-zastupujici-osoby-nova',
    EMITENT_ZASTUPUJICI_OSOBY_EDITACE: '/emitent-zastupujici-osoby-editace',
    EMITENT_ZASTUPUJICI_OSOBY_HISTORY: '/emitent-zastupujici-osoby-historie',
    AMLZ_HISTORIE: '/historicke-zadosti',
    DUVERNE_INFORMACE: '/duverne-informace',
    ME_POZADAVKY: '/duverne-informace/me-pozadavky',
    STATNI_SPRAVA_F1: '/duverne-informace/F1/:page?',
    STATNI_SPRAVA_F1A: '/duverne-informace/F1A/:page?',
    STATNI_SPRAVA_F3: '/duverne-informace/F3/:page?',
    STATNI_SPRAVA_F5: '/duverne-informace/F5/:page?',
    STATNI_SPRAVA_F6: '/duverne-informace/F6/:page?',
    STATNI_SPRAVA_F7: '/duverne-informace/F7/:page?',
    STATNI_SPRAVA_F8: '/duverne-informace/F8/:page?',
    STATNI_SPRAVA_F9: '/duverne-informace/F9/:page?',
    STATNI_SPRAVA_F15: '/duverne-informace/F15/:page?',
    STATNI_SPRAVA_F16: '/duverne-informace/F16/:page?',
    STATNI_SPRAVA_F17: '/duverne-informace/F17/:page?',
    STATNI_SPRAVA_F18: '/duverne-informace/F18/:page?',
    STATNI_SPRAVA_F20: '/duverne-informace/F20/:page?',
    STATNI_SPRAVA_F30: '/duverne-informace/F30/:page?',
    STATNI_SPRAVA_F25: '/duverne-informace/F25/:page?',
    STATNI_SPRAVA_F26: '/duverne-informace/F26/:page?',
    STATNI_SPRAVA_F27: '/duverne-informace/F27/:page?',
    STATNI_SPRAVA_F28: '/duverne-informace/F28/:page?',
    STATNI_SPRAVA_F38: '/duverne-informace/F38/:page?',
    STATNI_SPRAVA_F39: '/duverne-informace/F39/:page?',
    STATNI_SPRAVA_F45: '/duverne-informace/F45/:page?',
    STATNI_SPRAVA_F50: '/duverne-informace/F50/:page?',
    STATNI_SPRAVA_F52: '/duverne-informace/F52/:page?',
    STATNI_SPRAVA_F53: '/duverne-informace/F53/:page?',
    STATNI_SPRAVA_F56: '/duverne-informace/F56/:page?',
    STATNI_SPRAVA_F58: '/duverne-informace/F58/:page?',
    SLUZBY_PREHLED_AKTIVNICH_POZADAVKU: '/sluzby/prehled-aktivnich-pozadavku',
    SLUZBY_DETAIL_POZADAVKU: '/sluzby/detail-pozadavku',
    SLUZBY_DETAIL_POZADAVKU_DLT: '/sluzby/detail-pozadavku-dlt',
    SLUZBY_VLOZENI_RUCNI: '/sluzby/vlozeni/rucni',
    SLUZBY_VLOZENI_SOUBOR: '/sluzby/vlozeni/soubor',
    SLUZBY_NOVY_UPIS: '/sluzby/novy-upis',
    SLUZBY_NOVY_UPIS_SICAV: '/sluzby/novy-upis-sicav',
    SLUZBY_NOVY_PREVOD: '/sluzby/novy-prevod',
    SLUZBY_NOVY_NAVYSENI: '/sluzby/novy-navyseni',
    SLUZBY_NOVY_SICAV: '/sluzby/novy-sicav',
    SLUZBY_SEZNAM: '/sluzby/seznam',
    SLUZBY_SEZNAM_DLT: '/sluzby/seznam-dlt',
    SLUZBY_SEZNAM_DVP: '/sluzby/seznam-dvp',
    SLUZBY_HISTORICKE_POZADAVKY: '/sluzby/historicke-pozadavky',
    LEI: '/lei-prehled',
    LEI_LOGIN_AKTUALIZACE: '/lei-login-aktualizace',
    LEI_LOGIN_MUJDEP: '/lei-prihlaseni',
    EMITENT_LOGIN_MUJDEP: '/emitent-prihlaseni',
    SRD_LOGIN_MUJDEP: '/srd-prihlaseni',
    LOGIN_JINA_OSOBA: '/jinaosoba-prihlaseni',
    STATNISPRAVA_LOGIN_MUJDEP: '/statni-sprava-prihlaseni',
    LOGIN_ROZCESTNIK: '/prihlaseni-rozcestnik',
    LOGIN_ROZCESTNIKDLT: '/prihlaseni-rozcestnik-dlt',
    LEI_GLEIF: '/lei-gleif',
    LEI_DETAIL: '/lei-detail',
    LEI_PLATBA: '/lei-platobne-detaily',
    LEI_NOVY: '/lei-novy',
    LEI_PREVOD: '/lei-prevod',
    LEI_UPRAVA: '/lei-uprava',
    LEI_KONTAKT: '/lei-kontakt',
    LEI_SPRAVA: '/lei-sprava',
    LEI_FAKTURY: '/lei-faktury',
    LEI_PLATBA_LOGIN: '/platebni-brana-login/:hash?',

    LEI_PREHLED_UCTU: '/lei-prehled-uctu/:lei?',
    LEI_POPIS_SLUZBY: '/lei-popis-sluzby',
    ZAKNIHOVANE_CP: '/zaknihovane-cp',
    LISTINNE_CP: '/listinne-cp',
    SPRAVA_UCTU_EVIDENCNI_UDAJE: '/sprava-uctu-evidence',
    SPRAVA_UCTU_UZIVATELE: '/sprava-uctu-uzivatele',
    PREHLED_ZADOSTI_PODANE: '/prehled-podane-zadosti',
    PREHLED_ZADOSTI_ROZPRACOVANE: '/prehled-rozpracovane-zadosti',
    PREHLED_ZADOSTI_ZPRACOVANE: '/prehled-zpracovane-zadosti',
    PREHLED_ISIN_PRIDELENE: '/prehled-pridelene-isin',
    PROFIL_EMITENT_PREHLED: '/profil-emitent',
    DETAIL_UCTU: '/detail-uctu/:typ?',
    UZIVATELE_NOVY: '/uzivatele-novy',
    UZIVATELE_PREHLED: '/uzivatele-prehled',
    APLIKACNI_TEXTY: '/aplikacni-texty',
    DOKUMENTY_PREHLED: '/dokumenty-prehled',
    DOKUMENTY_NOVY: '/dokumenty-novy',
    DOKUMENTY_HISTORIE: '/dokumenty-historie',
    DOKUMENTY_LOGIN: '/dokumenty-login/:hash?',
    DOKUMENTY_SMS: '/dokumenty-podpis',
    DOKUMENTY_OMEZ_PREVOD: '/omezena-proveditelnost',
    BANKID_OVERENI: '/bankid-overeni/:hash?',
    CRS_DOTAZNIK_NOVY: '/crs-dotaznik-novy/:id?',
    CRS_DOTAZNIK_PREHLED: '/crs-dotaznik-prehled',
    CRS_DOTAZNIK_HISTORIE: '/crs-dotaznik-historie',

    // loginless routy
    LEI_LOGINLESS_ODKAZ: '/lei-cdcp-odkaz/:hash?',
    LEI_LOGINLESS: '/lei-cdcp/:typ?',
    LEI_LOGINLESS_FAQ: '/lei-cdcp-faq/',
    LEI_LOGINLESS_INFO: '/lei-cdcp-info/',
    LEI_LOGINLESS_ONAS: '/lei-cdcp-onas/',
    LEI_LOGINLESS_SEARCH: '/lei-cdcp-search',
    LEI_LOGINLESS_OSOBA: '/lei-cdcp-osoba/:hash?'
};
